import { render } from "./RoomCompTab.vue?vue&type=template&id=bf9bf302"
import script from "./RoomCompTab.vue?vue&type=script&lang=js"
export * from "./RoomCompTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__